// import the required animation functions from the angular animations module
import { trigger, state, animate, transition, style, AnimationTriggerMetadata } from '@angular/animations';

export const fadeInAnimation =
trigger('fadeInAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.3s', style({ opacity: 1 }))
    ]),
]);
